import { Builder } from '@builder.io/react';

import LogoGrid from './index';

Builder.registerComponent(LogoGrid, {
  name: 'LogoGrid',
  inputs: [
    {
      name: 'logos',
      type: 'list',
      defaultValue: [
        { name: 'blend' },
        { name: 'flexport' },
        { name: 'brex' },
        { name: 'sap' },
        { name: 'doma' },
        { name: 'paypal' },
        { name: 'square' },
        { name: 'openai' },
        { name: 'nvidia' },
        { name: 'gm' }
      ],
      subFields: [
        { name: 'name', type: 'string' },
        { name: 'src', type: 'file', allowedFileTypes: ['jpg', 'png', 'svg'] },
        { name: 'width', type: 'number' },
        { name: 'height', type: 'number' },
        { name: 'alt', type: 'string' }
      ]
    },
    {
      name: 'columns',
      type: 'object',
      defaultValue: { xs: 2, sm: 2, md: 5, lg: 5 },
      subFields: [
        { name: 'xs', type: 'number' },
        { name: 'sm', type: 'number' },
        { name: 'md', ype: 'number' },
        { name: 'lg', type: 'number' }
      ]
    }
  ]
});
